import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { MwSidebarComponent } from './sidebar.component';

@Injectable({ providedIn: 'root' })
export class MwSidebarService {
  sidebarStateChange = new Subject<MwSidebarComponent>();

  private readonly registry$: BehaviorSubject<{
    [key: string]: MwSidebarComponent;
  }> = new BehaviorSubject({});

  private registry: { [key: string]: MwSidebarComponent } = {};

  register(key: string, sidebar: MwSidebarComponent): void {
    if (this.registry[key]) {
      console.error(
        `The sidebar with the key '${key}' already exists. Either unregister it first or use a unique key.`
      );

      return;
    }

    this.registry[key] = sidebar;
    this.registry$.next(this.registry);
  }

  unregister(key: string): void {
    if (!this.registry[key]) {
      console.warn(
        `The sidebar with the key '${key}' doesn't exist in the registry.`
      );
    }

    delete this.registry[key];
    this.registry$.next(this.registry);
  }

  getSidebar(key: string): Observable<MwSidebarComponent> {
    return this.registry$.pipe(map((registry) => registry[key]));
  }
}
